

export default {
  exampleCount: (state, getters) => {
    return 0
  },
  getTitleColor: (state) => {
    switch (state.color) {
      case 'magenta': return 'magenta';
      case 'primary': return 'purple';
      case 'info': return 'blue';
      case 'warning': return 'orange';
      case 'orange-algebra': return 'orange-algebra';
      case 'success': return 'green';
      case 'danger': return 'red';
      default: return 'green';
    }
  },

  getTitleColorModal: (state) => {
    switch (state.color) {
      case 'danger': return 'error white--text';
      case 'primary': return 'purple white--text';
      default: return state.color + ' white--text';
    }
  }
  //
  // SECURITY
  //
  


}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/app/app_getters.js